import * as BaseApi from "../Base.api";

export const getInfoForKoach = async () => {
  const url = `/koach/info/koach`;
  return await BaseApi.get(url);
};